import { render } from "./BoxSupport.vue?vue&type=template&id=310884f6"
import script from "./BoxSupport.vue?vue&type=script&lang=js"
export * from "./BoxSupport.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__